/**
 * @file AddEditRoleDialog.jsx
 * @description Add/Edit Role Dialog component for displaying and managing roles.
 * @component AddEditRoleDialog
 * @exports AddEditRoleDialog - Main component for displaying and managing roles.
 */

import React from "react";
import { Button, TextField, Box } from "@mui/material";
import { ROLE_STRINGS, ROLE_KEYS } from "../../../common/constants/adminModule/roleConstants.js";
import { STRINGS, SIZES, VARIANTS, BUTTON_COLORS, AUTO_COMPLETE } from "../../../common/constants/commonConstants.js";
import DialogComponent from "../../../common/components/DialogComponent.jsx";

const AddEditRoleDialog = ({
    onSave,
    selectedRole,
    open,
    handleInputChange,
    onClose,
}) => {
    return (
        <>
            <DialogComponent
                open={open}
                setWidth="xs"
                onClose={onClose}
                title={selectedRole?.id ? ROLE_STRINGS.EDIT_ROLE : ROLE_STRINGS.ADD_ROLE}
                actions={
                    <Button
                        onClick={onSave}
                        variant={VARIANTS.CONTAINED}
                        color={BUTTON_COLORS.PRIMARY}
                    >
                        {STRINGS.SAVE}
                    </Button>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <TextField
                        fullWidth
                        size={SIZES.SMALL}
                        variant={VARIANTS.OUTLINED}
                        label={ROLE_STRINGS.ROLE_NAME}
                        autoComplete={AUTO_COMPLETE.OFF}
                        value={selectedRole?.rolename || ""}
                        onChange={handleInputChange(ROLE_KEYS.ROLE_NAME)}
                    />
                </Box>
            </DialogComponent>
        </>
    )
};

export default AddEditRoleDialog;